import React, { useState } from 'react';
import Logo from '../../assets/logo/LogoPittogrammaeScritta.svg';
import Plane from '../../assets/img/newsLetter/planeNews.svg';
import Loader from '../../assets/loader/loader.gif';
import { useTranslation } from 'react-i18next';
import api from '../../api';
import { showToast } from '../../components/toast/ToastNotifier';

const NewsLetter = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async () => {
    if (!email) return showToast.info('Inserisci un indirizzo email valido');

    setLoading(true);

    try {
      await api.post('/newsletter/subscribe', { email }, {
        customToastMessage: t('newsletter.success'),
      });

      setEmail('');
    } catch (error) {
      showToast.error(
        error?.response?.data?.message || 'Errore durante l\'iscrizione'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="text-start py-10 mb-16 border-t">
      <h3
        className="lg:text-3xl text-xl font-semibold font-heading my-6 text-center text-start uppercase"
        dangerouslySetInnerHTML={{ __html: t('newsletter.title') }}
      ></h3>

      <div className="flex flex-col md:flex-row justify-center items-center mb-6 space-y-6 md:space-y-0 md:space-x-6">
        <div className="flex justify-center md:justify-end">
          <img
            src={Loader}
            alt="Logo"
            className="h-[100px] w-[100px] lg:h-[150px] lg:w-[150px]"
          />
        </div>

        <div className="flex flex-col items-center md:items-start w-full md:w-auto space-y-4">
          <input
            type="email"
            placeholder={t('newsletter.placeholder')}
            className="w-5/6 md:w-96 py-2 md:py-4 px-4 lg:px-6 text-lg text-center rounded-lg border-2 border-gray-300"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button
            onClick={handleSubscribe}
            disabled={loading}
            className="w-5/6 md:w-96 py-2 uppercase md:py-4 px-4 lg:px-6 bg-wild-ocean font-heading text-white text-lg rounded-lg disabled:opacity-50"
          >
            {loading ? t('newsletter.loading') : t('newsletter.button')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewsLetter;
